var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 82,
    viewBox: "0 0 61 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4126_48636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.06114 82V71.9522L39.7377 40.3122C41.2564 38.7445 42.4497 37.2836 43.3176 35.9297C44.2577 34.5757 44.9086 33.2574 45.2702 31.9747C45.7041 30.6207 45.9211 29.2668 45.9211 27.9128C45.9211 25.1336 44.7278 22.8176 42.3412 20.9648C40.027 19.112 37.0618 18.1857 33.4458 18.1857C29.9744 18.1857 26.7561 18.8983 23.7909 20.3235C20.8258 21.6774 17.5713 24.0291 14.0276 27.3783L6 17.7581C10.2669 13.8387 14.7147 10.917 19.3432 8.99297C23.9717 6.99766 28.8172 6 33.8797 6C39.0145 6 43.5345 6.89076 47.4398 8.67229C51.3452 10.4538 54.3826 12.9123 56.5523 16.0478C58.7219 19.1833 59.8067 22.8533 59.8067 27.0577C59.8067 29.4805 59.4451 31.7609 58.7219 33.8987C58.071 36.0366 56.9862 38.21 55.4675 40.4191C53.9487 42.557 51.9237 44.8729 49.3925 47.3671L26.3945 70.135L61 70.0281V82H8.06114Z",
    fill: "hsla(200, 53%, 23%, 0.5)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4126_48636",
    x: 0,
    y: 0,
    width: 61,
    height: 82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -6,
    dy: -6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.913725 0 0 0 0 0.913725 0 0 0 0 0.972549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4126_48636"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4126_48636",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwo);
export default __webpack_public_path__ + "static/media/two.0a06570919bab411a201f4e342f22caf.svg";
export { ForwardRef as ReactComponent };